import {
  Box,
  IconButton,
  ButtonBase,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect } from "react";
import { ClearIcon } from "../../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ClearIcon";
import { RandomImageIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/RandomImageIcon";
import { ImprovePromptBtn } from "../../../ImageSuite/Components/Shared/ImprovePromptBtn";
import { useImproveVideoSuitePrompt } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import SignalRService from "../../../one-query/services/SignalRService";
import { tooltipStyles } from "../../../ImageSuite/Components/Shared/InputText";

interface WorkflowInputTextProps {
  handelGenerateRandomPrompt: () => void;
  IsGeneratePromptLoading: boolean;
  handleUserInputTextChange: (
    activeAppId: string,
    value: string | null
  ) => void;
  inputValue: string;
  generatedPrompt: string;
  readOnly: boolean;
  activeAppId: string;
}
const WorkflowInputText = ({
  handelGenerateRandomPrompt,
  IsGeneratePromptLoading,
  handleUserInputTextChange,
  inputValue,
  readOnly,
  generatedPrompt,
  activeAppId,
}: WorkflowInputTextProps) => {
  const responsiveSize = useMediaQuery("(max-width: 700px)");

  const handleInputValueChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    handleUserInputTextChange(activeAppId, event.target.value);
  };
  const {
    mutate: ImproveVideoPromptRequest,
    isPending: isVideoPromptImproving,
  } = useImproveVideoSuitePrompt();

  useEffect(() => {
    if (generatedPrompt.length > 0) {
      handleUserInputTextChange(activeAppId, "");
      handleUserInputTextChange(activeAppId, generatedPrompt);
    }
  }, [generatedPrompt]);

  const handelImprovePrompt = async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (inputValue) {
      const improvePromptRequestData = {
        prompt: inputValue,
        connectionId: connectionId,
      };
      ImproveVideoPromptRequest(improvePromptRequestData);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid var(--A-background55)",
        borderRadius: "12px",
        mt: "8px",
        padding: "8px",
      }}
    >
      <div className="input-suite-container">
        <textarea
          value={inputValue}
          onChange={handleInputValueChange}
          placeholder="Describe the video content you want to generate..."
          className="custom-textarea-suite"
          disabled={IsGeneratePromptLoading}
          rows={3}
          readOnly={readOnly}
        />
      </div>
      <Box className="input-failed-actions">
        {inputValue?.length > 0 ? (
          <Tooltip
            disableHoverListener={responsiveSize}
            disableFocusListener={responsiveSize}
            disableTouchListener={responsiveSize}
            title="Clear"
            arrow
            placement="top"
            componentsProps={tooltipStyles}
          >
            <ButtonBase
              className="input-failed-clear-text"
              onClick={() => handleUserInputTextChange(activeAppId, "")}
              disabled={IsGeneratePromptLoading || isVideoPromptImproving}
              sx={{
                opacity:
                  IsGeneratePromptLoading || isVideoPromptImproving ? 0.5 : 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <ClearIcon className="clear-input-icn" />
            </ButtonBase>
          </Tooltip>
        ) : (
          <Box></Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            gap: { xs: "4px", md: "8px" },
            alignItems: "center",
          }}
        >
          <ImprovePromptBtn
            handelImprovePrompt={handelImprovePrompt}
            isDisabled={
              isVideoPromptImproving ||
              inputValue?.length === 0 ||
              IsGeneratePromptLoading
            }
            inputValue={inputValue}
          />
          <IconButton
            className="input-failed-improve-text"
            onClick={handelGenerateRandomPrompt}
            disabled={IsGeneratePromptLoading || isVideoPromptImproving}
            sx={{
              opacity:
                IsGeneratePromptLoading || isVideoPromptImproving ? 0.5 : 1,
              cursor: "pointer",

              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <RandomImageIcon className="pro-plan-icon suites" />
            <Typography sx={{ color: "#12b6ea" }}>Inspire me</Typography>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkflowInputText;
